import ActionIcons from "../actionIcons";
export const getHeaderConfig = (loadData) => [
  {
    label: "Description",
    id: "description",
  },
  {
    label: "Actions",
    id: "actions",
    render: (data) => {
      return (
        <ActionIcons
          type="part"
          loadData={loadData}
          id={data.id}
          Description={data.description}
        />
      );
    },
  },
];
